{
    "DisplayasoptionsGrid": "Griglia",
    "DisplayasoptionsColumns": "Colonne",
    "DisplayasoptionsRows": "Righe",
    "DisplayasoptionsChart": "Grafico",
    "DisplayasoptionsDetailedtableview": "Vista dettagliata della tabella",
    "DisplayasoptionsBlfviewhorizontal": "Vista BLF (orizzontale)",
    "DisplayasoptionsBlfviewvertical": "Vista BLF (verticale)",
    "DisplayasoptionsChartview": "Vista del grafico",
    "NAME": "DisplayedAsOptions"
}